// edelkrone: menü v3 Products paneli (Taylan Ezer'in menü denemesi, 3 Kasım 2026).
// Sekmeler: fareyle üzerine gelince kısa bir beklemeyle, tıklayınca ve ok tuşlarıyla değişir.
// Videolar: menü açılınca görünen sekmedekiler yüklenip oynar, menü kapanınca ya da sekme değişince durur.
(() => {
  // Products ve Deals Zone panelleri bu dosyayı ayrı ayrı yükler; bir kez çalışır.
  if (window.ekm3Ready) return;
  window.ekm3Ready = true;

  const HOVER_DELAY = 90;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const isOpen = (root) => {
    const details = root.closest('details');
    return !details || details.open;
  };

  // "Bir kez" videoları (data-ekm3-once): ziyaret başına bir kez oynar ve son karede kalır. Oynadığı bu sekmede
  // sessionStorage'da tutulur; sonraki açılışlarda poster (son kare) görünür. Depolama kapalıysa sayfa başına bir kez.
  const playedKey = (video) => `ekm3-played:${video.dataset.ekm3Src.split('?')[0]}`;
  const wasPlayed = (video) => {
    if (video.dataset.ekm3Played) return true;
    try { return sessionStorage.getItem(playedKey(video)) === '1'; } catch (error) { return false; }
  };
  const markPlayed = (video) => {
    video.dataset.ekm3Played = 'true';
    try { sessionStorage.setItem(playedKey(video), '1'); } catch (error) { /* sayfa başına bir kez */ }
  };

  // Görünen sekmenin videoları oynar, gizlilerdeki durur. Kaynak ilk açılışta takılır (preload="none").
  // Hareket azaltma açıksa poster kalır; otomatik oynatma engellenirse de poster kalır.
  // Telefonda veri tasarrufu açıksa (Android "Data Saver", Chrome Lite) döngüler hiç yüklenmez, poster kalır.
  const saveData = !!(navigator.connection && navigator.connection.saveData);

  const syncVideos = (root) => {
    root.querySelectorAll('video[data-ekm3-src]').forEach((video) => {
      const visible = isOpen(root) && !video.closest('[hidden]');
      playOrPause(video, visible);
    });
  };

  const playOrPause = (video, visible) => {
    {
      const once = video.hasAttribute('data-ekm3-once');
      if (visible && !reduceMotion.matches && !saveData) {
        if (once && (video.ended || wasPlayed(video))) return;
        if (!video.getAttribute('src')) {
          if (once) {
            // İlk oynatmada açılış karesi görünür ki son kare (poster) önce belirip geri sıçramasın.
            const endPoster = video.poster;
            if (video.dataset.ekm3Start) video.poster = video.dataset.ekm3Start;
            video.addEventListener('ended', () => markPlayed(video), { once: true });
            video.src = video.dataset.ekm3Src;
            // Yalnız otomatik oynatma engellenirse son kare geri gelir; menü hızla kapanınca oluşan iptal (AbortError)
            // posteri değiştirmez, yoksa sonraki açılışta önce son kare görünüp başa sıçrardı.
            video.play().catch((error) => { if (error && error.name === 'NotAllowedError') video.poster = endPoster; });
            return;
          }
          video.src = video.dataset.ekm3Src;
        }
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }
  };

  // Telefon çekmecesi (.ekm3-m): videolar ekranda göründükçe yüklenip oynar, sayfa kapanınca ya da kaydırıp
  // ekrandan çıkınca durur. Çekmecenin gizli sayfaları (hidden) görünmediği için oynamaz.
  const watchMobileVideos = (root) => {
    if (!root.classList.contains('ekm3-m') || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => playOrPause(entry.target, entry.isIntersecting && !entry.target.closest('[hidden]')));
    }, { threshold: 0.25 });
    root.querySelectorAll('video[data-ekm3-src]').forEach((video) => observer.observe(video));
  };

  const select = (tab) => {
    const rail = tab.closest('[role="tablist"]');
    if (!rail || tab.getAttribute('aria-selected') === 'true') return;

    rail.querySelectorAll('[role="tab"]').forEach((other) => {
      const active = other === tab;
      other.setAttribute('aria-selected', active ? 'true' : 'false');
      other.tabIndex = active ? 0 : -1;
      const pane = document.getElementById(other.getAttribute('aria-controls'));
      if (pane) pane.hidden = !active;
    });

    const root = tab.closest('[data-ekm3]');
    if (root) syncVideos(root);
  };

  const initTabs = (root) => {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    let timer;

    tabs.forEach((tab, index) => {
      tab.addEventListener('pointerenter', (event) => {
        // Dokunmatik ekranda (iPad) parmakla kaydırırken sekme değişmesin: üzerine gelme yalnız fareyle; dokunma tıklamadır.
        if (event.pointerType && event.pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(() => select(tab), HOVER_DELAY);
      });
      tab.addEventListener('pointerleave', () => clearTimeout(timer));
      tab.addEventListener('click', () => select(tab));
      // Odaklanınca seçmiyoruz: Safari tıklamadan hemen sonra odağı bir önceki sekmeye geri verebiliyor ve sekme geri
      // sıçrıyordu (4 Kasım 2026 testi). Klavyede ok tuşları sekmeyi hem seçer hem odaklar; Home/End ilk ve son sekme.
      tab.addEventListener('keydown', (event) => {
        const key = event.key;
        let next = null;
        if (key === 'ArrowDown' || key === 'ArrowUp') next = tabs[(index + (key === 'ArrowDown' ? 1 : -1) + tabs.length) % tabs.length];
        else if (key === 'Home') next = tabs[0];
        else if (key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        select(next);
        next.focus();
      });
    });

    const details = root.closest('details');
    if (details) details.addEventListener('toggle', () => { fitPanel(root); syncVideos(root); });
  };

  // Panel pencereden taşmasın: açılınca başladığı yerden pencerenin altına kadar olan yer ölçülür, panel bu
  // yükseklikle sınırlanır, sığmazsa içinde kayar. Kısa dizüstü pencerelerinde (ör. 1536 × 730) alt satırlar kesilmez.
  const fitPanel = (root) => {
    // Telefon çekmecesindeki sayfalar çekmeceyle birlikte kayar, sınır yok.
    if (root.classList.contains('ekm3-m') || !isOpen(root)) return;
    const top = root.getBoundingClientRect().top;
    root.style.maxHeight = `${Math.max(240, Math.floor(window.innerHeight - top - 8))}px`;
    root.style.overflowY = 'auto';
  };

  // "Bundles with …" sırası: oklar bir sayfa kaydırır, sığıyorsa oklar gizlenir, uçta olan ok sönük kalır.
  const initStrips = (root) => {
    root.querySelectorAll('.ekm3__strip').forEach((strip) => {
      const nav = strip.parentElement.querySelector('.ekm3__strip-nav');
      if (!nav) return;
      const [prev, next] = nav.querySelectorAll('[data-ekm3-strip]');

      const update = () => {
        const max = strip.scrollWidth - strip.clientWidth;
        nav.hidden = max <= 2;
        prev.disabled = strip.scrollLeft <= 2;
        next.disabled = strip.scrollLeft >= max - 2;
      };

      nav.addEventListener('click', (event) => {
        const button = event.target.closest('[data-ekm3-strip]');
        if (!button) return;
        strip.scrollBy({ left: Number(button.dataset.ekm3Strip) * strip.clientWidth * 0.8 });
      });
      strip.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(strip);
      update();
    });
  };

  const run = () => document.querySelectorAll('[data-ekm3]').forEach((root) => {
    if (root.dataset.ekm3Ready) return;
    root.dataset.ekm3Ready = 'true';
    initTabs(root);
    initStrips(root);
    watchMobileVideos(root);
  });

  // Fırsat kartlarındaki geri sayım (data-ekm3-countdown = bitiş, ISO): gün, saat, dakika, saniye kutuları.
  // Süreli öğeler (data-ekm3-until = bitiş, ISO): süre dolunca tarayıcıda hemen gizlenir (önbellekteki sayfada da).
  // Fırsat satırında kalan kart sayısına göre sütunlar yeniden ayarlanır.
  const pad = (n) => String(n).padStart(2, '0');
  const expire = () => {
    document.querySelectorAll('[data-ekm3-until]:not([hidden])').forEach((el) => {
      const end = Date.parse(el.dataset.ekm3Until);
      if (!(end <= Date.now())) return;
      el.hidden = true;
      const list = el.closest('.ekm3-deals');
      if (!list) return;
      const count = Math.min(5, list.querySelectorAll(':scope > li:not([hidden])').length);
      list.style.setProperty('--ekm3-deals', count);
      list.className = list.className.replace(/ekm3-deals--\d+/, `ekm3-deals--${count}`);
    });
  };
  const tickCountdowns = () => {
    expire();
    document.querySelectorAll('[data-ekm3-countdown]').forEach((el) => {
      const left = Date.parse(el.dataset.ekm3Countdown) - Date.now();
      if (!(left > 0)) { el.remove(); return; }
      const parts = [
        [Math.floor(left / 86400000), 'days'],
        [Math.floor(left / 3600000) % 24, 'hours'],
        [Math.floor(left / 60000) % 60, 'min'],
        [Math.floor(left / 1000) % 60, 'sec'],
      ];
      el.innerHTML = parts.map(([value, label]) => `<span class="ekm3-cd"><b>${pad(value)}</b><i>${label}</i></span>`).join('');
    });
  };
  if (document.querySelector('[data-ekm3-countdown], [data-ekm3-until]')) {
    tickCountdowns();
    setInterval(tickCountdowns, 1000);
  }

  run();
  document.addEventListener('shopify:section:load', run);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => document.querySelectorAll('[data-ekm3]').forEach(fitPanel), 120);
  });
})();
